import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, unwrap } from "./api";

/**
 * Seeds the calling tenant with one starter service for the given
 * template key, plus the booking custom fields, PLAN-tier inventory
 * items, and (where applicable) ADDON inventory + service-inventory
 * links. Powers the "Pick a starter pack" step in the post-signup
 * onboarding wizard.
 *
 * Idempotent: re-running for an already-seeded template returns the
 * existing service with all `*Created` counts equal to zero.
 */

export type SeedTemplateKey =
  | "photography"
  | "salon"
  | "coaching"
  | "fitness"
  | "gown_rental"
  | "clinic";

export function useSeedServices() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (templateKey: SeedTemplateKey) =>
      unwrap(
        await api.POST("/api/v1/services/seed", {
          body: { templateKey },
        }),
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["services"] });
      qc.invalidateQueries({ queryKey: ["inventory"] });
    },
  });
}
